/* global Highcharts module window:true */
(function (factory) {
    if (typeof module === "object" && module.exports) {
        module.exports = factory;
    } else {
        factory(Highcharts);
    }
}(function (Highcharts) {

    Highcharts.setOptions({
        lang: {
            thousandsSep: ",",
            decimalPoint: ".",

            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            numericSymbols: ["k", "M", "G", "T", "P", "E"],

            loading: "Loading...",
            printChart: "Print chart",
            downloadJPEG: "Download JPEG image",
            downloadPNG: "Download PNG image",
            downloadSVG: "Download SVG image",
            downloadPDF: "Download PDF document",
            downloadCSV: "Download CSV data",
            viewFullscreen: "View in full screen",
            rangeSelectorFrom: "From",
            rangeSelectorTo: "To",
            rangeSelectorZoom: "Zoom",
            resetZoom: "Reset zoom",
            resetZoomTitle: "Reset zoom level 1:1",
            zoomIn: "Zoom in",
            zoomOut: "Zoom out",
            drillUpText:"\u25c1 Back to {series.name}",

            embedChart: "Embed",
            copyToClipboard: "Copy to clipboard",
            copiedToClipboard: "Copied to clipboard!",
        }
    });

}));
